import * as React from "react";
import { InputContainerProps } from "../../elements/InputContainer";
import ColorInput from "../../elements/ColorInput";
import ToggleFloatingLayer from "../ToggleFloatingLayer";
import { ChromePicker } from "react-color";
import posed from "react-pose";

const Wrapper = posed.div({
  enter: {
    opacity: 1,
    transition: {
      duration: 100
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 100
    }
  }
});

type Props = {
  value: string | null;
  onChange: (value: string) => void;
} & InputContainerProps;

export default function ColorPicker({ value, onChange, ...rest }: Props) {
  return (
    <ToggleFloatingLayer
      closeOnOutsideClick
      positions={{
        layer: ["right", "top"],
        parent: ["right", "bottom"]
      }}
      layer={
        <Wrapper>
          <ChromePicker
            disableAlpha
            color={value!}
            onChange={(color: any) => onChange(color.hex)}
          />
        </Wrapper>
      }
    >
      {({ toggle }) => (
        <ColorInput
          value={value}
          onColorClick={toggle}
          onChange={(evt: any) => onChange(evt.target.value.replace(/\s/g, ""))}
          {...rest}
        />
      )}
    </ToggleFloatingLayer>
  );
}
